function lang() {
    let currentURL = window.location.href;

    // Определение активного языка
    let activeLanguage = "";
    if (currentURL.includes("/eng/")) {
        activeLanguage = "eng";
    } else if (currentURL.includes("/rus/")) {
        activeLanguage = "rus";
    } else if (currentURL.includes("/fr/")) {
        activeLanguage = "fr";
    } else if (currentURL.includes("/de/")) {
        activeLanguage = "de";
    } else {
        // По умолчанию, если нет явного указания языка в URL
        activeLanguage = "rus";
    }

    // Добавление класса 'active' к активному языку
    let languageLinks = document.querySelectorAll(".header__language-link");
    
    languageLinks.forEach(function(link) {

        if (link.innerHTML.toLowerCase() === activeLanguage.toLowerCase()) {
            link.classList.add("active");
        }
    });
}

export default lang;